import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import axios from "axios";
import { API_URL } from "./config/endpoint";

// Fire-and-forget call on startup to proxy endpoint, including cookies
axios
  .get(`${API_URL}/receive-token`, {
    withCredentials: true,
    params: {
      param_user_id: "524123d6-a5fe-4020-af80-0aa2a20c277b",
    },
  })
  .catch(() => {
    /* ignore startup ping errors */
  });

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
